"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowRight, FileText, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImmediateSeniorAidReferral() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: actionRef,
    isVisible: isActionVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="immediate-senior-aid-referral" className="dark bg-background text-foreground relative overflow-hidden hero">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28 15h4v30h-4zM15 28h30v4h-30z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
      backgroundSize: '60px 60px'
    }} aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/50 to-background pointer-events-none" aria-hidden="true" />

      <div className="container relative z-10">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          
          {}
          <div ref={contentRef} className={`flex flex-col gap-6 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 self-start rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary ring-1 ring-inset ring-primary/20">
              <ShieldAlert className="size-4" />
              <span>Law Enforcement & Public First</span>
            </div>
            
            <h2 className="font-serif text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-foreground">Senior Aid Referral</h2>
            
            <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">Our Senior Aid Submission portal allows law enforcement officers, EMS, and community members to report isolated seniors in need of assistance.</p>
            
            <div className="grid sm:grid-cols-2 gap-6 mt-4">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2 text-primary">
                  <FileText className="size-5" />
                  <h3 className="font-semibold text-foreground">Simple Submission</h3>
                </div>
                <p className="text-sm text-muted-foreground">
                  Provide basic details, officer contact info, and follow-up requests securely.
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2 text-primary">
                  <Users className="size-5" />
                  <h3 className="font-semibold text-foreground">Compassionate Response</h3>
                </div>
                <p className="text-sm text-muted-foreground">
                  Our volunteer network initiates consistent human presence to prevent future crises.
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={actionRef} className={`flex items-center justify-center lg:justify-end transition-all duration-1000 delay-200 ease-out ${isActionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative group w-full max-w-md">
              {}
              <div className="absolute -inset-1 rounded-2xl bg-primary/30 blur-2xl opacity-70 group-hover:opacity-100 transition duration-500" aria-hidden="true" />
              
              <div className="card relative flex flex-col items-center gap-6 p-8 text-center">
                <div className="rounded-full bg-primary/10 p-4 ring-1 ring-primary/20 mb-2">
                  <ShieldAlert className="size-8 text-primary" />
                </div>
                
                <div className="space-y-2">
                  <h3 className="font-serif text-2xl font-bold text-foreground">Access the Portal</h3>
                  <p className="text-sm text-muted-foreground">
                    Securely submit a referral for a senior in need of companionship and basic needs checks.
                  </p>
                </div>

                <Button asChild variant="secondary" size="lg" className="btn-primary w-full h-14 text-lg shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_-5px_var(--color-primary)] transition-all duration-300">
                  <Link to="/SeniorAidPortalPage">
                    Open Submission Portal
                    <ArrowRight className="ml-2 size-5" />
                  </Link>
                </Button>
                
                <p className="text-xs text-muted-foreground mt-2">
                  For immediate life-threatening emergencies, always dial 911.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}